module.exports = __webpack_public_path__ + "img/e601fde8be354d0bc0a6203b69f5900e.46e0ab48.png";